import UsersDataTable from "../../../../components/dataTable/custom/UsersDataTable";

function UsersPageView() {
  return <UsersDataTable />;
}

export default UsersPageView;
